import { Box, HStack, Input, Text } from "@chakra-ui/react";
import { useSetDateGeneMap } from "../../routes/registries/stores/actions/useSetDateGeneMap";
import { useSelectDateGeneMap } from "../../routes/registries/stores/select/useSelectDateGeneMap";
import { MaterialIcon } from "../shared/MaterialIcon";

interface IProps {}

const GeneMapDateBar = (props: IProps) => {
  const dateGeneMap = useSelectDateGeneMap();
  const setDateGeneMap = useSetDateGeneMap();

  const handleOnDateStartChange = (e) => {
    setDateGeneMap({ dateGeneMap: e.target.value });
  };

  return (
    <Box>
      <HStack
        justifyContent={"center"}
        alignItems="center"
        py="2"
        px="6"
        bg="bg.high"
        spacing={8}
        borderTop={"1px"}
        borderColor="border"
      >
        <HStack>
          <MaterialIcon name="biotech" fontSize="1.5rem" variant="outline" />

          <Text fontWeight="semibold">Select New Case Date:</Text>
        </HStack>

        <HStack flex={1} spacing={4}>
          <Box>
            <Input
              data-testid="GeneMapDateBar-Input"
              value={dateGeneMap || ""}
              shadow="sm"
              size="sm"
              type="date"
              onChange={handleOnDateStartChange}
              colorScheme={"gray"}
            />
          </Box>
        </HStack>
      </HStack>
    </Box>
  );
};

export default GeneMapDateBar;
